import { render, staticRenderFns } from "./AdditionalDataField.vue?vue&type=template&id=6288963a&"
import script from "./AdditionalDataField.vue?vue&type=script&lang=js&"
export * from "./AdditionalDataField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VChip,VInput})
